import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const LabelWithTooltip = ({ id, tooltip, children, placement }) => {
	return <OverlayTrigger placement={placement || 'right'} overlay={<Tooltip id={id}>{tooltip}</Tooltip>}>
		<span>{children}</span>
	</OverlayTrigger>;
};

export default LabelWithTooltip;